import { createQuery } from 'react-query-kit';
import { ErrorResponse, privateApi } from 'api';
import { AxiosError } from 'axios';
import { Payment } from './GetPayment';

export type GetPaymentsParams = {
    studentId: string;
}

export type GetPaymentsResult = Payment[] | null;

async function getPayments(params: GetPaymentsParams): Promise<GetPaymentsResult | null> {
    // create new URL object for the API endpoint
    const requestUrl = new URL(`${import.meta.env.VITE_API_BASE_URL}/finance/payments`);

    // create new URLSearchParams object to store query parameters
    const searchParams = new URLSearchParams();

    // add each parameter to searchParams if the value is not null or undefined
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            searchParams.set(key, String(value));
        }
    });

    // add the query string to the requestUrl
    requestUrl.search = searchParams.toString();

    // make api call
    const result = await privateApi.get(requestUrl.toString());

    // return the data object
    return result.data as GetPaymentsResult;
}

const useGetPayments = createQuery<GetPaymentsResult, GetPaymentsParams, AxiosError<ErrorResponse>>({
    queryKey: ['payments'],
    fetcher: (variables) => getPayments(variables),
})

export { useGetPayments };

